import { BaseService } from "./base.service";
export class UniversityTypeService extends BaseService {
  constructor() {
    super("university-types");
  }
}
